import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button, IconButton, Slide, Grow, Fade, Snackbar as MuiSnackbar, Card, CardContent, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { closeQueueSnackbar } from 'store/slices/queueSnackBar';
import { Box } from '@mui/system';

// animation functions
const animation = {
    SlideLeft: (props) => <Slide {...props} direction="left" />,
    SlideUp: (props) => <Slide {...props} direction="up" />,
    SlideRight: (props) => <Slide {...props} direction="right" />,
    SlideDown: (props) => <Slide {...props} direction="down" />,
    Grow: (props) => <Grow {...props} />,
    Fade
};

const QueueSnackBar = () => {
    const dispatch = useDispatch();
    const { currentSnackbar, queue = [] } = useSelector((state) => state.queuesnackbar);
    const {
        actionButton,
        anchorOrigin,
        alert,
        close,
        message,
        open = false,
        transition,
        autoHideDuration,
        newMessage
    } = currentSnackbar || {};
    const [openSnackBar, setOpenSnackBar] = useState(false);

    useEffect(() => {
        if (currentSnackbar && currentSnackbar?.open) {
            setTimeout(() => setOpenSnackBar(true), 1000);
        }
    }, [currentSnackbar]);

    const handleClose = (_, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackBar(false);
        setTimeout(() => dispatch(closeQueueSnackbar()), 1000);
    };

    if (!currentSnackbar) return null;

    const MessageText = ({ messageKey, value, showBar = true }) => {
        if (messageKey && value) {
            return (
                <Typography
                    variant="subtitle1"
                    sx={{
                        color: '#757575',
                        fontSize: '14px'
                    }}
                >
                    {`${messageKey} -`} <span style={{ fontWeight: 500, color: 'black' }}>{`${value || `-`} ${showBar ? '|' : ''} `}</span>
                </Typography>
            );
        }
        return <></>;
    };

    const MessageData = ({ message }) => {
        const {
            booking_code: bookingCode = '',
            category = '',
            request_type: requestType = '',
            message: ticketMessage = ''
        } = message || {};
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', width: '100%', margin: '5px' }}>
                <Box display="flex" gap="5px" flexWrap="wrap" width="100%">
                    <MessageText messageKey="Booking Code" value={bookingCode} />
                    <MessageText messageKey="Category" value={category} />
                    <MessageText messageKey="Request Type" value={requestType} showBar={false} />
                </Box>
                {ticketMessage && (
                    <Typography
                        sx={{
                            color: '#555555',
                            fontSize: '14px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                        variant="subtitle1"
                    >{`Message- ${ticketMessage}`}</Typography>
                )}
            </Box>
        );
    };

    return (
        <>
            <MuiSnackbar
                TransitionComponent={animation.SlideLeft}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={openSnackBar}
                autoHideDuration={autoHideDuration}
                onClose={handleClose}
            >
                <Card
                    sx={{
                        display: 'flex',
                        background: '#FFF8E1',
                        width: '580px',
                        height: 'fit-content',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        position: 'relative'
                    }}
                >
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 6,
                            top: 4,
                            color: (theme) => theme.palette.grey[500],
                            marginTop: '2px',
                            marginLeft: '40px'
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <CardContent sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        {newMessage && (
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px',
                                        fontWeight: 500
                                    }}
                                    mb={1.2}
                                    noWrap
                                >
                                    New Message
                                </Typography>
                            </Box>
                        )}
                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                            <MessageData message={message} />
                        </Box>
                    </CardContent>
                </Card>
            </MuiSnackbar>
        </>
    );
};

export default QueueSnackBar;
